export const environment = {
  production: true,
  maxPhotoSizeInKb: 512,
  apiEndpoint: null, // injected
  clientId: null, // injected
  tenantId: null, // injected
};
